// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"Tutorial_videoWrapper__UlpYx","video":"Tutorial_video__26Jqb","videoPlaying":"Tutorial_videoPlaying__2gVaA"};